import { render } from "./Changelogs.vue?vue&type=template&id=179e4b9a&scoped=true"
import script from "./Changelogs.vue?vue&type=script&lang=js"
export * from "./Changelogs.vue?vue&type=script&lang=js"

import "./Changelogs.vue?vue&type=style&index=0&id=179e4b9a&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/xsurflog_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-179e4b9a"]])

export default __exports__